module.exports = __webpack_public_path__ + "img/textBtm3.5cd5c52c.png";